import styled from 'styled-components'

export const Heading5 = styled.h5``
